var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M40,41H8c-2.206,0-4-1.794-4-4V11c0-2.206,1.794-4,4-4h32c2.206,0,4,1.794,4,4v26 C44,39.206,42.206,41,40,41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M34,12.98H14.02c-2.2,0-4,1.79-4,4V30c0,1.86,1.27,3.42,2.98,3.86v-2.14 c-0.59-0.35-0.98-0.99-0.98-1.72V16.98c0-1.1,0.9-2,2-2H34c1.1,0,2,0.9,2,2V30c0,0.74-0.4,1.38-1,1.73v2.14c1.73-0.44,3-2.01,3-3.87 V16.98C38,14.77,36.21,12.98,34,12.98z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M16.5,28L16.5,28c0.828,0,1.5,0.672,1.5,1.5v5c0,0.828-0.672,1.5-1.5,1.5l0,0 c-0.828,0-1.5-0.672-1.5-1.5v-5C15,28.672,15.672,28,16.5,28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M21.5,22L21.5,22c0.828,0,1.5,0.672,1.5,1.5v11c0,0.828-0.672,1.5-1.5,1.5l0,0 c-0.828,0-1.5-0.672-1.5-1.5v-11C20,22.672,20.672,22,21.5,22z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M26.5,25L26.5,25c0.828,0,1.5,0.672,1.5,1.5v8c0,0.828-0.672,1.5-1.5,1.5l0,0 c-0.828,0-1.5-0.672-1.5-1.5v-8C25,25.672,25.672,25,26.5,25z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M31.5,18L31.5,18c0.828,0,1.5,0.672,1.5,1.5v15c0,0.828-0.672,1.5-1.5,1.5l0,0 c-0.828,0-1.5-0.672-1.5-1.5v-15C30,18.672,30.672,18,31.5,18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/BI.77d15c152be6b62b0d11df437eeefff1.svg";
export { ForwardRef as ReactComponent };